<agpr-master-layout
    [id]="'main'"
    [layout]="layout"
    (click)="emptyHandler()"
    (mousedown)="emptyHandler()"
>
    <ng-template agprTemplate="navigation">
        <a
            class="agpr-skipLink"
            tabindex="0"
            [href]="skipLinkPath"
        >
            <span class="agpr-skipLink-text"> {{ 'PrimaryNav.skipLinkMessage' | localize }} </span>
        </a>
        <ng-container *ngIf="showMasterLayout">
            <header tabindex="-1" class="agpr-masterLayout-navigation">
                <agpr-navbar
                    [leftItems]="primaryNav.left"
                    [rightItems]="primaryNav.right"
                    [supportLinks]="primaryNav.supportLinks"
                    [logoUrl]="logoUrl"
                    [logoRouterLink]="logoRouterLink"
                ></agpr-navbar>
            </header>
            <agpr-impersonator-banner></agpr-impersonator-banner>
            <div
                class="agpr-notification-banners"
            >
                <agpr-message
                    *ngFor="let warning of maintenanceWarnings; index as i"
                    class="agpr-notification-banners-banner"
                    [severity]="warning.type"
                    [isSystemNotification]="true"
                    (updateNotification)="handleNotificationUpdate($event)"
                    [systemNotification]="warning"
                    (dismiss)="handleDismissal(warning)"
                ></agpr-message>
                <agpr-message
                    *ngFor="let notification of notifications; index as i"
                    class="agpr-notification-banners-banner"
                    [severity]="notification.type"
                    [isSystemNotification]="true"
                    (updateNotification)="handleNotificationUpdate($event)"
                    [systemNotification]="notification"
                    (dismiss)="handleDismissal(notification)"
                ></agpr-message>
            </div>
            <agpr-growler></agpr-growler>
        </ng-container>
    </ng-template>
</agpr-master-layout>

<button
    *ngIf="showIntercom"
    id="agpr-intercom"
    [agprTooltip]="'Core.intercom' | localize"
    [showDelay]="500"
    [style.zIndex]="zIndex"
    tooltipPosition="left"
    (keyup)="intercomKeyup($event)"

>
    <span
        *ngIf="intercomUnreadCount > 0"
        class="agpr-intercom-count"
    >
        {{ intercomUnreadCount }}
    </span>
</button>
